/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Search_PlaceholderInputs */

const en_user_search_placeholder = /** @type {(inputs: User_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search users...`)
};

const ja_user_search_placeholder = /** @type {(inputs: User_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ユーザーを検索...`)
};

const fr_user_search_placeholder = /** @type {(inputs: User_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechercher des utilisateurs...`)
};

const de_user_search_placeholder = /** @type {(inputs: User_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer suchen...`)
};

/**
* | output |
* | --- |
* | "Search users..." |
*
* @param {User_Search_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const user_search_placeholder = /** @type {((inputs?: User_Search_PlaceholderInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Search_PlaceholderInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_user_search_placeholder(inputs)
	if (locale === "ja") return ja_user_search_placeholder(inputs)
	if (locale === "fr") return fr_user_search_placeholder(inputs)
	return de_user_search_placeholder(inputs)
});